export interface Role {
  value: string;
  viewValue: string;
}

export interface RolePermission {
  module: string;
  actions: string[];
}

export const AVAILABLE_ROLES: Role[] = [
  { value: 'ROLE_SUPER_ADMIN', viewValue: 'Super Admin' },
  { value: 'ROLE_ADMIN', viewValue: 'Admin' },
  { value: 'ROLE_TESORERO', viewValue: 'Tesorero' }
];

export const ROLE_PERMISSIONS: Record<string, RolePermission[]> = {
  'ROLE_SUPER_ADMIN': [
    { module: 'dashboard', actions: ['read', 'write', 'delete'] },
    { module: 'user', actions: ['read', 'write', 'delete'] },
    { module: 'driver', actions: ['read', 'write', 'delete'] },
    { module: 'client', actions: ['read', 'write', 'delete'] },
    { module: 'supplier', actions: ['read', 'write', 'delete'] },
    { module: 'freight', actions: ['read', 'write', 'delete'] },
    { module: 'invoice', actions: ['read', 'write', 'delete'] },
    { module: 'settings', actions: ['read', 'write', 'delete'] },
    { module: 'reports', actions: ['read', 'write', 'delete'] }
  ],
  'ROLE_ADMIN': [
    { module: 'dashboard', actions: ['read'] },
    { module: 'user', actions: ['read', 'write', 'delete'] },
    { module: 'driver', actions: ['read', 'write', 'delete'] },
    { module: 'client', actions: ['read', 'write', 'delete'] },
    { module: 'freight', actions: ['read', 'write', 'delete'] },
    { module: 'invoice', actions: ['read', 'write', 'delete'] }
  ],
  'ROLE_TESORERO': [
    { module: 'dashboard', actions: ['read'] },
    { module: 'user', actions: ['read'] },
    { module: 'driver', actions: ['read'] },
    { module: 'freight', actions: ['read', 'write'] },
    { module: 'invoice', actions: ['read', 'write'] }
  ]
};

export const MODULE_ROUTES: Record<string, string[]> = {
  'dashboard': ['/dashboard'],
  'user': ['/dashboard/user'],
  'driver': ['/dashboard/driver'],
  'client': ['/dashboard/client'],
  'supplier': ['/dashboard/supplier'],
  'freight': ['/dashboard/freight'],
  'invoice': ['/dashboard/invoice'],
  'bill': ['/dashboard/bill'],
  'income': ['/dashboard/income'],
  'expense': ['/dashboard/expense'],
  'cash-movement': ['/dashboard/cash-movement'],
  'payment-method': ['/dashboard/payment-method'],
  'cash-movement-concept': ['/dashboard/cash-movement-concept'],
  'settings': ['/dashboard/configuration'],
  'reports': ['/dashboard/reports']
};
